module.exports = {
  localizedContent: {
    brand: 'Brand*',
    model: 'Model*',
    finish: 'Finish',
    title: 'Title*',
    description: 'Description*',
    charactersLeft: '%{count} characters remaining',
  },
  warnings: {
    capsWarning: 'Whoa there! Please don\'t use SO MANY CAPS in your title.',
  },
  additionalInformation: 'Tell us a little more to help your listing sell faster:',
  headers: {
    attributes: 'What are you selling?',
    edit: 'Edit',
  },
  attributes: {
    make: {
      label: 'Brand*',
      labelHint: 'e.g. Fender',
      tooltip: "If you don't know the brand, use something <br> like 'Unknown', or 'Handmade' as appropriate",
      locked_tooltip_html: 'We automatically categorized your <br> listing to help it get found and sold',
    },
    model: {
      label: 'Model*',
      labelHint: 'e.g. Stratocaster',
    },
    year: {
      label: 'Year',
      tooltip: "<h4 class='heading-4'>You can use fuzzy dates!</h4><br/> If you don't know the exact year your item was<br/> made, try a decade like <strong>90s</strong> or <strong>1990s</strong>, or a part of the <br/> decade, such as <strong>late-70s</strong>, <strong>early 80s</strong>, <strong>mid-2000s</strong>.<br/> You can also use ranges like <strong>1953 - 1957</strong>.",
    },
    finish: {
      label: 'Finish/Color',
    },
    country: {
      label: 'Country Of Manufacturer',
    },
    title: {
      label: 'Listing Title*',
    },
  },
  makeModelForm: {
    make: {
      label: 'Brand*',
      labelHint: 'e.g. Fender',
      lockedTooltipHtml: 'We automatically categorized your <br> listing to help it get found and sold',
    },
    model: {
      label: 'Model*',
      labelHint: 'e.g. Stratocaster',
    },
  },
  newBrandRequest: {
    requestABrand: 'Request a New Brand',
    brandName: 'Brand Name*',
    description: 'Description*',
    website: 'Brand Website',
    websiteHint: 'e.g. www.fender.com',
    submit: 'Submit Request',
    gotRequest: 'We\'ve Got Your Request',
    expectToHear: 'You can expect to hear from us within two business days.',
    pleaseContact: 'Please contact brandrequests@reverb.com with questions.',
    dontRecognize: 'We don\'t recognize that brand. Please check the spelling.',
    couldBeDifficult: 'Listing with a brand we don\'t recognize could make your listing difficult for buyers to find.',
    pleaseSubmitHtml: 'To add a new brand name on Reverb, please submit a %{linkOpen}new brand request%{linkClose}.',
    registrationWallMessage: 'request a new brand.',
    errorMsg: 'Woah there, please fix the following before continuing:',
  },
};



// WEBPACK FOOTER //
// ./javascripts/translations/listing_form/en.js